/** SDK 内置版本号，构建时由 package.json 注入 */
declare const __SDK_VERSION__: string;

export const SDK_VERSION = __SDK_VERSION__;
